import type { APIListingPerformanceStat } from "models/types/api-listing";
import { AD_PLATFORMS } from "modules/vendor-portal/screens/performance/utils/ad-platform-details";

export function mergeTradeMeViews(
  data?: APIListingPerformanceStat[],
): APIListingPerformanceStat[] {
  if (!data || data.length === 0) return [];
  const dataWithoutTradeMe: APIListingPerformanceStat[] = [];
  let dailyIndex = -1;
  let summaryIndex = -1;

  data.forEach((obj, i) => {
    if (obj.format.id !== "nz_trademe") {
      dataWithoutTradeMe.push(obj);
    } else if (obj.type === "daily") {
      dailyIndex = i;
    } else if (obj.type === "summary") {
      summaryIndex = i;
    }
  });

  const tradeMeImpressionsKey = AD_PLATFORMS.nz_trademe.impressions_key;

  // If either not found or impression key is null, return original array without Trade Me data (we need both to form a single view)
  if (
    dailyIndex === -1 ||
    summaryIndex === -1 ||
    tradeMeImpressionsKey === null
  ) {
    return dataWithoutTradeMe;
  }

  const dailyObj = data[dailyIndex];
  const summaryObj = data[summaryIndex];

  // Sum all views from daily
  const totalViews = Object.values(dailyObj.value).reduce<number>(
    (sum, val) => {
      if (
        typeof val === "object" &&
        val !== null &&
        tradeMeImpressionsKey in val &&
        typeof (val as Record<string, number>)[tradeMeImpressionsKey] ===
          "number"
      ) {
        return sum + (val as Record<string, number>)[tradeMeImpressionsKey];
      }
      return sum;
    },
    0,
  );

  const updatedSummary: APIListingPerformanceStat = {
    ...summaryObj,
    value: {
      ...summaryObj.value,
      summary: {
        ...summaryObj.value.summary,
        [tradeMeImpressionsKey]: totalViews,
      },
    },
  };

  return [...dataWithoutTradeMe, updatedSummary];
}
